import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import type {
  LoggerProvider,
  LogPayload,
} from 'app/components/common/ErrorLogger/core/types';

export class DatadogLoggingProvider implements LoggerProvider {
  log(payload: LogPayload): void {
    const context = {
      type: payload.type,
      ...payload.tags,
      ...payload.context,
      ...payload.metadata,
    };

    if (payload.error) {
      // Surfaces in Datadog RUM > Error Tracking, grouped by error fingerprint
      datadogRum.addError(payload.error, context);
    } else {
      // Forward non-error logs to Datadog Logs
      datadogLogs.logger[
        payload.level === 'critical' ? 'error' : payload.level
      ](payload.message, context);
    }
  }
}
